import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueDrawingCanvas = _resolveComponent("VueDrawingCanvas")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(_component_VueDrawingCanvas, {
      ref: "vueCanvasDrawingRef",
      width: _ctx.canvasOptions.width,
      height: _ctx.canvasOptions.height,
      "stroke-type": _ctx.canvasOptions.strokeType,
      "line-cap": _ctx.canvasOptions.lineCap,
      "line-join": _ctx.canvasOptions.lineJoin,
      "fill-shape": _ctx.canvasOptions.fillShape,
      eraser: _ctx.canvasOptions.eraser,
      lineWidth: _ctx.canvasOptions.lineWidth,
      color: _ctx.canvasOptions.color,
      "background-color": _ctx.canvasOptions.backgroundColor,
      "background-image": _ctx.canvasOptions.backgroundImage,
      watermark: _ctx.canvasOptions.watermark,
      "initial-image": _ctx.canvasOptions.initialImage,
      saveAs: _ctx.canvasOptions.saveAs,
      styles: _ctx.canvasOptions.styles,
      lock: _ctx.canvasOptions.lock,
      "additional-images": _ctx.canvasOptions.additionalImages
    }, null, 8, ["width", "height", "stroke-type", "line-cap", "line-join", "fill-shape", "eraser", "lineWidth", "color", "background-color", "background-image", "watermark", "initial-image", "saveAs", "styles", "lock", "additional-images"]), [
      [_vShow, _ctx.isShow.canvas]
    ]),
    (!_ctx.isShow.canvas)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _ctx.rentalContractEditForm.signaturePath,
          class: "img-fluid",
          style: {"border":"solid 1px #000"}
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true)
  ], 64))
}